import { render, staticRenderFns } from "./goods_search.vue?vue&type=template&id=b57d2d84&scoped=true"
import script from "./goods_search.vue?vue&type=script&lang=js"
export * from "./goods_search.vue?vue&type=script&lang=js"
import style0 from "./goods_search.vue?vue&type=style&index=0&id=b57d2d84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57d2d84",
  null
  
)

export default component.exports